import { PromptStarter } from "@/types/lora";

export const promptStyles: PromptStarter[] = [
    {
      id: '1',
      name: 'Linkedin',
      image: 'https://prompz-bucket.s3.amazonaws.com/69699/K75qTqfHk_rcQSSYd5l24_f6c794f5aea6420e9558699983f70ee8.png',
      prompt:
        '8k linkedin professional profile photo of @taylorbe63 woman in a suit with studio lighting, bokeh, corporate portrait headshot photograph best corporate photography photo winner, meticulous detail, hyperrealistic, centered uncropped symmetrical beautiful',
    },
    {
      id: '2',
      name: 'Dream Style',
      image: '/placeholder.svg?height=100&width=100',
      prompt:
        '8k linkedin professional profile photo of @taylorbe63 woman in a suit with studio lighting, bokeh, corporate portrait headshot photograph best corporate photography photo winner, meticulous detail, hyperrealistic, centered uncropped symmetrical beautiful',
      loraModel: {
        id: 1,
        name: 'Dream Style',
        image: 'https://prompz-bucket.s3.amazonaws.com/69700/hvl6lO7D9SM1GbBj3XVEa_0d80dfe19a794d9ca48585faf63a16ac.png',
        trigger_word: 'pnt style'
      }
    },
    {
      id: '3',
      name: 'Half Illustrated',
      image: 'https://prompz-bucket.s3.amazonaws.com/69705/udvdMiOyoHvk8uL6yKKNa_420d1600dc674a3f972ce7e91635e448.png',
      prompt:
        'In the style of TOK, a photo editorial avant-garde dramatic action pose of @man wearing 90s round wacky sunglasses pulling glasses down looking forward, in Seattle at sunset with a vibrant illustrated jacket surrounded by illustrations of flowers, smoke, flames, ice cream, sparkles, rock and roll',
      loraModel: {
        id: 334,
        name: 'Half Illustrated',
        image: 'https://prompz-bucket.s3.amazonaws.com/69705/udvdMiOyoHvk8uL6yKKNa_420d1600dc674a3f972ce7e91635e448.png',
        trigger_word: 'in the style of TOK'
      }
    },
    {
      id: '5',
      name: 'RDR2',   
      image: '/placeholder.svg?height=100&width=100',
      prompt: '@alex, video game screenshot in the style of RDRGM'
    },
    {
      id: '6',
      name: 'Tarot Style',
      image: '/placeholder.svg?height=100&width=100',
      prompt: '8k linkedin professional profile photo of @taylorbe63 woman in a suit with studio lighting, bokeh, corporate portrait headshot photograph best corporate photography photo winner, meticulous detail, hyperrealistic, centered uncropped symmetrical beautiful'
    },
    {
      id: '7',
      name: "80's Stylish",
      image: '/placeholder.svg?height=100&width=100',
      prompt: '8k linkedin professional profile photo of @taylorbe63 woman in a suit with studio lighting, bokeh, corporate portrait headshot photograph best corporate photography photo winner, meticulous detail, hyperrealistic, centered uncropped symmetrical beautiful'
    },
    {
      id: '8',
      name: "80's Cyberpunk",
      image: '/placeholder.svg?height=100&width=100',
      prompt: '8k linkedin professional profile photo of @taylorbe63 woman in a suit with studio lighting, bokeh, corporate portrait headshot photograph best corporate photography photo winner, meticulous detail, hyperrealistic, centered uncropped symmetrical beautiful'
    },
    {
      id: '9',
      name: 'Fashion',
      image: '/placeholder.svg?height=100&width=100',
      prompt: '8k linkedin professional profile photo of @taylorbe63 woman in a suit with studio lighting, bokeh, corporate portrait headshot photograph best corporate photography photo winner, meticulous detail, hyperrealistic, centered uncropped symmetrical beautiful'
    },
    {
      id: '10',
      name: 'Ninja',
      image: '/placeholder.svg?height=100&width=100',
      prompt: '8k linkedin professional profile photo of @taylorbe63 woman in a suit with studio lighting, bokeh, corporate portrait headshot photograph best corporate photography photo winner, meticulous detail, hyperrealistic, centered uncropped symmetrical beautiful'
    },
  ];